import React, { Suspense } from 'react';

export function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(23,70,67,0.25),_transparent_40%),linear-gradient(180deg,#f7f0e2_0%,#efe3cf_100%)] px-6 dark:bg-[radial-gradient(circle_at_top,_rgba(89,168,158,0.18),_transparent_35%),linear-gradient(180deg,#101516_0%,#182122_100%)]">
      <div className="rounded-full border border-black/10 bg-white/70 px-5 py-3 text-xs font-semibold uppercase tracking-[0.28em] text-stone-600 backdrop-blur dark:border-white/10 dark:bg-white/5 dark:text-stone-300">
        Loading Arena
      </div>
    </div>
  );
}

export function WithLoader({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}
